import { create } from 'zustand'

type RecoveryBannerStoreState = {
  recoveryBannerHeight: number
  setRecoveryBannerHeight: (height: number) => void
}

const useRecoveryBannerStore = create<RecoveryBannerStoreState>(set => ({
  recoveryBannerHeight: 0,
  setRecoveryBannerHeight: (height: number) => set({ recoveryBannerHeight: height }),
}))

export default useRecoveryBannerStore

/**
 * Shared height of the desktop recovery prompt banner. It's fixed-positioned and
 * only mounted on Home, so fixed elements elsewhere (e.g. the nav avatar and
 * in-app notifications) can offset themselves by this value. Resets to 0 when
 * the banner unmounts.
 */
export const useRecoveryBannerHeight = () => {
  const recoveryBannerHeight = useRecoveryBannerStore(state => state.recoveryBannerHeight)
  const setRecoveryBannerHeight = useRecoveryBannerStore(state => state.setRecoveryBannerHeight)

  return {
    recoveryBannerHeight,
    setRecoveryBannerHeight,
  }
}
